export default {"src":"/_next/static/media/ellipse3.57157e92.svg","height":176,"width":176,"blurWidth":0,"blurHeight":0};